/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';

export type TSendTimerModel = IModel<ISendTimerRequest, TSendTimerResponse>;

export interface ISendTimerRequest {
  /** Ключ по которому устанавливаем время **/
  key: string;
  /** Знание в секундах **/
  value: number;
}

export type TSendTimerResponse = ISendTimerResponse200 | ISendTimerResponse400;

export interface ISendTimerResponse200 extends IModelResponse<ISendTimerResponse> {
  statusCode: 200;
}

export interface ISendTimerResponse400 extends IModelResponse<ISendTimerResponseError> {
  statusCode: 400;
}

export interface ISendTimerResponse {
  /** Статус ответа **/
  status: EStatus;
}

export interface ISendTimerResponseError {
  errors: any[];
  message: string;
}

export type TResponses = ISendTimerResponse | ISendTimerResponseError;

export enum EStatus {
  /** OK **/
  Ok = 'ok',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: ISendTimerResponse): TResponse200;
  400(response: ISendTimerResponseError): TResponse400;
}
